import cloneDeep from 'lodash/cloneDeep'

export function cloneVariables(variables) {
  const newObject = { ...variables }

  if (variables.SETS) {
    newObject.SETS = variables.SETS.map(v => cloneDeep(v))
  }

  return newObject
}

export function convertWeightByTimezone(weight, unitSystem = 'metric', toLBS = false, toImperialDigits = 0, toMetricDigits = 2) {
  if (weight === null) return null

  if (unitSystem === 'imperial') {
    return toLBS ? parseFloat((weight * 2.20462).toFixed(toImperialDigits)) : parseFloat((weight / 2.20462).toFixed(toMetricDigits))
  }

  return weight
}

export function convertHeightByUnitSystem(height, unitSystem = 'metric', toFT = false, toImperialDigits = 0, toMetricDigits = 2) {
  if (height === null) return null

  if (unitSystem === 'imperial') {
    return toFT ? parseFloat((height * 0.0328).toFixed(toImperialDigits)) : parseFloat((height / 0.0328).toFixed(toMetricDigits))
  }

  return height
}

export function convertDistanceByUnitSystem(distance, unitSystem = 'metric', toFeet = false, toImperialDigits = 0, toMetricDigits = 2) {
  if (distance === null) return null

  if (unitSystem === 'imperial') {
    return toFeet ? parseFloat((distance * 3.28084).toFixed(toImperialDigits)) : parseFloat((distance / 3.28084).toFixed(toMetricDigits))
  }

  return distance
}

export function convertSpeedByUnitSystem(speed, unitSystem = 'metric', toMPH = false, toImperialDigits = 0, toMetricDigits = 2) {
  if (speed === null) return null

  if (unitSystem === 'imperial') {
    return toMPH ? parseFloat((speed * 0.621371).toFixed(toImperialDigits)) : parseFloat((speed / 0.621371).toFixed(toMetricDigits))
  }

  return speed
}

export function weightSuffix(unitSystem = 'metric') {
  if (unitSystem === 'imperial') {
    return 'lbs'
  }

  return 'kg'
}

export function heightSuffix(unitSystem = 'metric') {
  if (unitSystem === 'imperial') {
    return 'ft'
  }

  return 'cm'
}

export function distanceSuffix(unitSystem = 'metric') {
  if (unitSystem === 'imperial') {
    return 'ft'
  }

  return 'm'
}
